import { render } from "./managerLayout.vue?vue&type=template&id=12009852&scoped=true"
import script from "./managerLayout.vue?vue&type=script&lang=js"
export * from "./managerLayout.vue?vue&type=script&lang=js"

import "./managerLayout.vue?vue&type=style&index=0&id=12009852&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12009852"]])

export default __exports__